import { Box, Typography, TextField } from '@mui/material';

export function WSPLocationFields({ localNodeData, updateNodeData }) {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
        Coordenadas *
      </Typography>
      <TextField
        label="Latitud"
        value={localNodeData.latitude || ''}
        size="small"
        fullWidth
        sx={{ mb: 1 }}
        onChange={(e) => updateNodeData('latitude', e.target.value)}
      />
      <TextField
        label="Longitud"
        value={localNodeData.longitude || ''}
        size="small"
        fullWidth
        sx={{ mb: 2 }}
        onChange={(e) => updateNodeData('longitude', e.target.value)}
      />

      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
        Información adicional (opcional)
      </Typography>
      <TextField
        label="Nombre del lugar"
        value={localNodeData.locationName || ''}
        size="small"
        fullWidth
        sx={{ mb: 1 }}
        onChange={(e) => updateNodeData('locationName', e.target.value)}
      />
      <TextField
        label="Dirección"
        value={localNodeData.locationAddress || ''}
        size="small"
        fullWidth
        onChange={(e) => updateNodeData('locationAddress', e.target.value)}
      />
    </Box>
  );
}